import React from 'react';

interface PaginationControlsProps {
  offset: number;
  limit: number;
  count: number;
  onPageChange: (offset: number) => void;
  disabled?: boolean;
  className?: string;
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  offset,
  limit,
  count,
  onPageChange,
  disabled = false,
  className = 'pagination-controls',
}) => {
  const currentPage = Math.floor(offset / limit) + 1;
  const totalPages = Math.ceil(count / limit) || 1;
  const hasNextPage = offset + limit < count;
  const hasPrevPage = offset > 0;

  return (
    <div className={className}>
      <button
        onClick={() => onPageChange(0)}
        disabled={!hasPrevPage || disabled}
        className="pagination-btn"
      >
        First
      </button>
      <button
        onClick={() => onPageChange(Math.max(0, offset - limit))}
        disabled={!hasPrevPage || disabled}
        className="pagination-btn"
      >
        Previous
      </button>
      <span className="page-info">
        Page {currentPage} of {totalPages}
      </span>
      <button
        onClick={() => onPageChange(offset + limit)}
        disabled={!hasNextPage || disabled}
        className="pagination-btn"
      >
        Next
      </button>
      <button
        onClick={() => onPageChange(Math.floor((count - 1) / limit) * limit)}
        disabled={!hasNextPage || disabled}
        className="pagination-btn"
      >
        Last
      </button>
    </div>
  );
};
